import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";

const AssignSupplierToItemModal = ({ modal, currentItem, suppliers }) => {
    const userID = secureLocalStorage.getItem("userID");
    const {
        handleSubmit,
        formState: { errors },
        control,
        setValue,
    } = useForm();
    const { useFetch: useFetchGeneric } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { useCreate } = useAPIQuery({
        key: "supplier-item",
        endpoint: "/api/supplier-item-association/",
    });

    const {
        data: genericData,
        isLoading: genericDataLoading,
        isFetching: genericDataIsFetching,
    } = useFetchGeneric({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { mutate, isPending } = useCreate({
        params: {
            action: "bulk_upload",
        },
        successMessageFromServer: true,
        errorMessageFromServer: true,
    });

    const onSubmit = (data) => {
        console.log(currentItem);
        console.log(data);
        console.log({
            item_id: currentItem?.id,
            supplier_ids: data?.supplier?.map((s) => s?.value),
            created_by: userID,
            updated_by: userID,
        });
        mutate({
            data: {
                item_id: currentItem?.id,
                supplier_ids: data?.supplier?.map((s) => s?.value),
                created_by: userID,
                updated_by: userID,
            },
        });
    };

    useEffect(() => {
        console.log(suppliers);
        if (suppliers) {
            setValue("supplier", suppliers);
        }
    }, [suppliers]);
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);
    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`assign-supplier-to-item-modal`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button className="close" data-bs-dismiss="modal">
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Assign Supplier</h5>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="modal-body">
                            <div className="col-12">
                                <label className="form-label">
                                    Supplier
                                    <span className="fs-8 text-danger">*</span>
                                </label>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="w-100 me-2">
                                        <Controller
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={
                                                        genericData
                                                            ? genericData.supplier?.map(
                                                                  (s) => ({
                                                                      value: s?.id,
                                                                      label:
                                                                          s?.first_name +
                                                                          " " +
                                                                          s?.last_name,
                                                                  })
                                                              )
                                                            : []
                                                    }
                                                    isLoading={
                                                        genericDataLoading ||
                                                        genericDataIsFetching
                                                    }
                                                    isClearable={true}
                                                    id="select-forms-supplier"
                                                    isMulti
                                                />
                                            )}
                                            defaultValue=""
                                            rules={{ required: true }}
                                            name="supplier"
                                            control={control}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-bs-toggle="modal"
                                        data-bs-target="#create-supplier-modal"
                                    >
                                        +
                                    </button>
                                </div>
                                {errors.supplier && (
                                    <span className="fs-8 text-danger">
                                        Supplier is required
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            {modal ? (
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-toggle="modal"
                                    data-bs-target="#create-po-modal"
                                    disabled={isPending}
                                >
                                    Back
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                    disabled={isPending}
                                >
                                    Close
                                </button>
                            )}
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isPending}
                            >
                                {isPending ? "Loading..." : "Assign Supplier"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AssignSupplierToItemModal;
